import { injectGlobal } from 'emotion';

injectGlobal`

.react-numeric-input input {
	border-radius: 0.58571429rem !important;
	border-bottom-right-radius: 0.58571429rem !important;
	border-top-left-radius: 0.98571429rem !important;
	border-bottom-left-radius: 0.98571429rem !important;
}

.react-numeric-input > b:nth-of-type(1) {
	border-top-right-radius: 0.98571429rem !important;
	border-top-left-radius: 0.98571429rem !important;
	border-bottom-right-radius: 0 !important;
	border-bottom-left-radius: 0 !important;
}

.react-numeric-input > b:nth-of-type(2) {
	border-top-right-radius: 0 !important;
	border-top-left-radius: 0 !important;
	border-bottom-right-radius: 0.98571429rem !important;
	border-bottom-left-radius: 0.98571429rem !important;	
}

#root {
    height: 100vh;
}

.ui.container {
  width: 1400px !important;
}

.clear {
    clear: both;
}

.field.eight > div.DayPickerInput {
    width: 100%;
}

<style type="text/css">@font-face{font-family:calluna;src:url(https://use.typekit.net/af/bccc98/000000000000000000014868/27/l?subset_id=2&fvd=n3&v=3) format("woff2"),url(https://use.typekit.net/af/bccc98/000000000000000000014868/27/d?subset_id=2&fvd=n3&v=3) format("woff"),url(https://use.typekit.net/af/bccc98/000000000000000000014868/27/a?subset_id=2&fvd=n3&v=3) format("opentype");font-weight:300;font-style:normal;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/3e64fb/00000000000000003b9b12fe/27/l?subset_id=2&fvd=n3&v=3) format("woff2"),url(https://use.typekit.net/af/3e64fb/00000000000000003b9b12fe/27/d?subset_id=2&fvd=n3&v=3) format("woff"),url(https://use.typekit.net/af/3e64fb/00000000000000003b9b12fe/27/a?subset_id=2&fvd=n3&v=3) format("opentype");font-weight:300;font-style:normal;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/4eabcf/00000000000000003b9b12fd/27/l?subset_id=2&fvd=n4&v=3) format("woff2"),url(https://use.typekit.net/af/4eabcf/00000000000000003b9b12fd/27/d?subset_id=2&fvd=n4&v=3) format("woff"),url(https://use.typekit.net/af/4eabcf/00000000000000003b9b12fd/27/a?subset_id=2&fvd=n4&v=3) format("opentype");font-weight:400;font-style:normal;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/f3ba4f/00000000000000003b9b12fa/27/l?subset_id=2&fvd=n7&v=3) format("woff2"),url(https://use.typekit.net/af/f3ba4f/00000000000000003b9b12fa/27/d?subset_id=2&fvd=n7&v=3) format("woff"),url(https://use.typekit.net/af/f3ba4f/00000000000000003b9b12fa/27/a?subset_id=2&fvd=n7&v=3) format("opentype");font-weight:700;font-style:normal;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/a386b3/00000000000000003b9b12f9/27/l?subset_id=2&fvd=i3&v=3) format("woff2"),url(https://use.typekit.net/af/a386b3/00000000000000003b9b12f9/27/d?subset_id=2&fvd=i3&v=3) format("woff"),url(https://use.typekit.net/af/a386b3/00000000000000003b9b12f9/27/a?subset_id=2&fvd=i3&v=3) format("opentype");font-weight:300;font-style:italic;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/e32ad9/00000000000000003b9b12fb/27/l?subset_id=2&fvd=i4&v=3) format("woff2"),url(https://use.typekit.net/af/e32ad9/00000000000000003b9b12fb/27/d?subset_id=2&fvd=i4&v=3) format("woff"),url(https://use.typekit.net/af/e32ad9/00000000000000003b9b12fb/27/a?subset_id=2&fvd=i4&v=3) format("opentype");font-weight:400;font-style:italic;}@font-face{font-family:europa;src:url(https://use.typekit.net/af/a6fa4a/00000000000000003b9b12fc/27/l?subset_id=2&fvd=i7&v=3) format("woff2"),url(https://use.typekit.net/af/a6fa4a/00000000000000003b9b12fc/27/d?subset_id=2&fvd=i7&v=3) format("woff"),url(https://use.typekit.net/af/a6fa4a/00000000000000003b9b12fc/27/a?subset_id=2&fvd=i7&v=3) format("opentype");font-weight:700;font-style:italic;}</style>
`;



// WEBPACK FOOTER //
// ./src/styling/global.js